/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var PageableCollection = require('psa-backbone/models/PageableCollection');
var GridView = require('psa-marionette/views/GridView');
var UIUtil = require('psa-core/util/ui');

var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var MomentCell = require('common/backgrid/MomentCell');

var GetCorrespondence = require('../../../securities/tasks/services/GetCorrespondence');

var SecCorrespondenceModalView = require('./SecCorrespondenceModalView');

var tmplSecCorrespondenceView = require('../templates/SecCorrespondenceView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecCorrespondenceView,

  className: function() {
    var mode = this.options.mode || 'default';
    return 'sec-correspondence-view sec-correspondence-view-' + mode;
  },

  ui: {
    correspondenceContainer: '.correspondence-container'
  },

  regions: {
    correspondenceContainer: '@ui.correspondenceContainer'
  },

  onBeforeShow: function() {
    var columns = [
      {
        name: 'source',
        label: 'Source',
        cell: 'string',
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'requestedBy',
        label: 'Requested By',
        cell: 'string',
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'requestedOn',
        label: 'Requested On',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'repliedBy',
        label: 'Replied By',
        cell: 'string',
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'repliedOn',
        label: 'Replied On',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: '',
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: 'Open',
              buttonClass: 'btn-primary btn-sm view-correspondence-details',
              onClick: this.onClickViewCorrespondence.bind(this)
            }
          ]
        }),
        editable: false,
        sortable: false,
        headerCell: 'custom',
        width: 5
      }
    ];

    if (this.options.mode === 'org') {
      columns.splice(1, 0, {
        name: 'type',
        label: 'Type',
        cell: 'string',
        headerCell: 'custom',
        width: 12,
        editable: false
      });
    }

    var secCorrespondenceGrid = new GridView({
      columns: columns,
      collection: new PageableCollection(this.model.get('correspondences'), { pageSize: 10 }),
      emptyText: 'No Related Correspondences'
    });
    this.showChildView('correspondenceContainer', secCorrespondenceGrid);
  },

  onClickViewCorrespondence: function(e, model) {
    e.preventDefault();
    var mode = this.options.mode;
    GetCorrespondence(model.get('id')).done(function(correspondence) {
      correspondence.isInternal = model.get('isInternal');
      correspondence.type = model.get('type');
      UIUtil.showModal({
        title: model.get('isInternal') === '1' ? 'Internal Correspondence Details' : 'External Correspondence Details',
        view: new SecCorrespondenceModalView({
          mode: mode,
          model: new Backbone.Model(correspondence)
        })
      });
    });
  }
});
